import { useEffect, useMemo, useRef, useState } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { useToast } from './Toast';
import StudioIcon from './StudioIcon';
export default function LatexViewer({ onChange, latex = '', extracting = false, zoom = 1 }) {
  const toast = useToast();
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const preview = useMemo(() => {
    if (!latex.trim()) return { html: '', error: '' };
    try { return { html: katex.renderToString(latex, { displayMode: true, throwOnError: true, trust: false, maxExpand: 1000, maxSize: 20 }), error: '' }; }
    catch (error) { return { html: '', error: error.message }; }
  }, [latex]);
  const copy = async () => {
    try { await navigator.clipboard.writeText(latex); setCopied(true); toast.success('Copied!'); clearTimeout(timer.current); timer.current = setTimeout(() => setCopied(false), 1500); }
    catch { toast.error('Clipboard unavailable; copy from the code editor.'); }
  };
  const download = () => {
    const url = URL.createObjectURL(new Blob([latex], { type: 'application/x-tex' }));
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'equation.tex'; anchor.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <div className="studio-output">
    <section className="studio-code-card">
      <div className="studio-card-heading"><span><StudioIcon name="code" size={16} />LaTeX source</span><button onClick={copy} disabled={!latex || extracting} title="Copy LaTeX"><StudioIcon name={copied ? 'check' : 'copy'} size={15} />{copied ? 'Copied!' : 'Copy'}</button></div>
      <textarea aria-label="Edit LaTeX" spellCheck={false} value={latex} readOnly={!onChange} disabled={extracting} onChange={event => onChange?.(event.target.value)} placeholder={extracting ? 'Recognizing your equation…' : 'Enter or edit LaTeX here…'} style={{ fontSize: `${.83 * zoom}rem` }} />
    </section>
    <section className="studio-math-card">
      <div className="studio-card-heading"><span>Rendered preview</span><small>LIVE</small></div>
      {preview.error ? <div className="studio-render-warning"><strong>Preview unavailable</strong><p>Your code is preserved. Some valid LaTeX commands are not supported in this preview.</p><details><summary>Show details</summary><p>{preview.error}</p></details></div>
        : preview.html ? <div className="studio-math" style={{ fontSize: `${zoom}em` }} dangerouslySetInnerHTML={{ __html: preview.html }} />
        : <p className="studio-preview-placeholder">Your equation preview will appear here.</p>}
    </section>
    <button className="studio-btn studio-btn--download" onClick={download} disabled={!latex || extracting}><StudioIcon name="download" size={16} />Download .tex</button>
    <p className="studio-fidelity-note">Compare the transcription with your original equation before using it.</p>
  </div>;
}
